import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from 'react';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { Spacing } from '@front/sharedcomponents/Variables';
import { NumericUpDownButton } from './NumericUpDownButton';
import { useHoldToRepeat } from './useHoldToRepeat';
export const NumericArrows = ({ onIncrement, onDecrement, disabled = false }) => {
    const incrementRef = useRef(onIncrement);
    const decrementRef = useRef(onDecrement);
    useEffect(() => {
        incrementRef.current = onIncrement;
    }, [onIncrement]);
    useEffect(() => {
        decrementRef.current = onDecrement;
    }, [onDecrement]);
    const stableIncrement = () => {
        incrementRef.current();
    };
    const stableDecrement = () => {
        decrementRef.current();
    };
    const holdUpActions = useHoldToRepeat({
        onAction: stableIncrement,
        disabled
    });
    const holdDownActions = useHoldToRepeat({
        onAction: stableDecrement,
        disabled
    });
    return (_jsxs(Stack, { className: "numeric-up-down-buttons", direction: "column", align: "center", spacing: Spacing.None, children: [_jsx(NumericUpDownButton, { isUp: true, onPointerDown: holdUpActions.startHold, onPointerUp: holdUpActions.stopHold, onPointerLeave: holdUpActions.stopHold, onPointerCancel: holdUpActions.stopHold }), _jsx(NumericUpDownButton, { isUp: false, onPointerDown: holdDownActions.startHold, onPointerUp: holdDownActions.stopHold, onPointerLeave: holdDownActions.stopHold, onPointerCancel: holdDownActions.stopHold })] }));
};
NumericArrows.displayName = 'NumericArrows';
